var map = {
	"./24-alert-triangle-line-red.svg": [
		75768,
		5768
	],
	"./24-alert-triangle-line.svg": [
		18519,
		8519
	],
	"./24-arrow-down.svg": [
		21797,
		1797
	],
	"./24-arrow-left.svg": [
		46840,
		6840
	],
	"./24-arrow-right.svg": [
		95671,
		5671
	],
	"./24-arrow-up.svg": [
		11173,
		1173
	],
	"./24-book.svg": [
		701,
		701
	],
	"./24-cart-normal.svg": [
		17123,
		7123
	],
	"./24-cart-normal_2.svg": [
		6780,
		6780
	],
	"./24-cart-normal_3.svg": [
		32459,
		2459
	],
	"./24-cart-notification.svg": [
		89742,
		9742
	],
	"./24-checkmark-green.svg": [
		62718,
		2718
	],
	"./24-checkmark.svg": [
		25555,
		5555
	],
	"./24-checkmark_2.svg": [
		69384,
		9384
	],
	"./24-chevron-down.svg": [
		60126,
		126
	],
	"./24-chevron-left.svg": [
		10715,
		715
	],
	"./24-chevron-right.svg": [
		90745,
		745
	],
	"./24-chevron-up.svg": [
		44746,
		4746
	],
	"./24-clipboard.svg": [
		56835,
		6835
	],
	"./24-clock.svg": [
		17728,
		7728
	],
	"./24-close.svg": [
		64375,
		4375
	],
	"./24-comunicazioni.svg": [
		71610,
		1610
	],
	"./24-customize.svg": [
		45119,
		5119
	],
	"./24-dati.svg": [
		15690,
		5690
	],
	"./24-documents.svg": [
		36642,
		6642
	],
	"./24-edit.svg": [
		62015,
		2015
	],
	"./24-gift.svg": [
		35141,
		5141
	],
	"./24-grid-a-2-v-1.svg": [
		63890,
		3890
	],
	"./24-grid-a-3-v-1.svg": [
		31023,
		1023
	],
	"./24-indirizzi.svg": [
		69015,
		9015
	],
	"./24-larghezza.svg": [
		55257,
		5257
	],
	"./24-logo.svg": [
		36386,
		6386
	],
	"./24-logo_2.svg": [
		68508,
		8508
	],
	"./24-minus-circle.svg": [
		45222,
		5222
	],
	"./24-offerte.svg": [
		91409,
		1409
	],
	"./24-orders.svg": [
		70774,
		774
	],
	"./24-pdf.svg": [
		16782,
		6782
	],
	"./24-plus-circle.svg": [
		35040,
		5040
	],
	"./24-plus.svg": [
		57057,
		7057
	],
	"./24-profile-2.svg": [
		95739,
		5739
	],
	"./24-remove.svg": [
		67039,
		7039
	],
	"./24-star.svg": [
		51745,
		1745
	],
	"./24-star_2.svg": [
		38791,
		8791
	],
	"./24-tag.svg": [
		72838,
		2838
	],
	"./24-wishlist-line.svg": [
		28694,
		8694
	],
	"./24-zoom.svg": [
		24134,
		4134
	],
	"./32-pdf.svg": [
		72424,
		2424
	],
	"./32-xls.svg": [
		40803,
		803
	],
	"./32-xml.svg": [
		80538,
		538
	],
	"./40-alert.svg": [
		96880,
		6880
	],
	"./40-pdf.svg": [
		50263,
		263
	],
	"./40-xls.svg": [
		15497,
		5497
	],
	"./40-xml.svg": [
		52947,
		2947
	],
	"./alert-triangle-line-red.svg": [
		42926,
		2926
	],
	"./arrow-down.svg": [
		90819,
		819
	],
	"./arrow-left.svg": [
		76765,
		6765
	],
	"./arrow-right.svg": [
		90357,
		357
	],
	"./arrow-up.svg": [
		55711,
		5711
	],
	"./bin.svg": [
		4709,
		4709
	],
	"./book.svg": [
		36901,
		6901
	],
	"./car.svg": [
		8096,
		8096
	],
	"./cart.svg": [
		80106,
		106
	],
	"./checkmark-green.svg": [
		36505,
		6505
	],
	"./checkmark-white.svg": [
		90733,
		733
	],
	"./checkmark.svg": [
		82711,
		2711
	],
	"./chevron-down.svg": [
		48849,
		8849
	],
	"./chevron-left.svg": [
		7631,
		7631
	],
	"./chevron-right.svg": [
		84767,
		4767
	],
	"./chevron-up.svg": [
		6777,
		6777
	],
	"./clipboard.svg": [
		6575,
		6575
	],
	"./clock.svg": [
		19351,
		9351
	],
	"./close.svg": [
		29250,
		9250
	],
	"./comunicazioni.svg": [
		64189,
		4189
	],
	"./customize.svg": [
		36483,
		6483
	],
	"./dati.svg": [
		44803,
		4803
	],
	"./download.svg": [
		30749,
		749
	],
	"./e-mail.svg": [
		11153,
		1153
	],
	"./edit.svg": [
		8348,
		8348
	],
	"./gift.svg": [
		49829,
		9829
	],
	"./icon-16-checkmark-circle-2.svg": [
		38718,
		8718
	],
	"./icon-16-goccia.svg": [
		99124,
		9124
	],
	"./icon-24-filter.svg": [
		71371,
		1371
	],
	"./icon-24-search.svg": [
		83936,
		3936
	],
	"./icon-32-custom.svg": [
		29120,
		9120
	],
	"./icon-32-customer-service.svg": [
		39025,
		9025
	],
	"./icon-32-imballi.svg": [
		26482,
		6482
	],
	"./icon-32-qualit.svg": [
		37864,
		7864
	],
	"./icon-32-timer.svg": [
		38087,
		8087
	],
	"./illustration-posizione-1.svg": [
		29287,
		9287
	],
	"./illustration-posizione-2.svg": [
		97996,
		7996
	],
	"./illustration-posizione-3.svg": [
		55049,
		5049
	],
	"./indirizzi.svg": [
		44866,
		4866
	],
	"./info.svg": [
		12211,
		2211
	],
	"./logo-sipec.svg": [
		22764,
		2764
	],
	"./logo.svg": [
		37408,
		7408
	],
	"./minus-circle.svg": [
		44833,
		4833
	],
	"./minus.svg": [
		77529,
		7529
	],
	"./offerte.svg": [
		79930,
		9930
	],
	"./orders.svg": [
		39300,
		9300
	],
	"./pdf.svg": [
		21469,
		1469
	],
	"./pin.svg": [
		87068,
		7068
	],
	"./plus-circle.svg": [
		80311,
		311
	],
	"./plus.svg": [
		56802,
		6802
	],
	"./plus_2.svg": [
		46033,
		6033
	],
	"./remove.svg": [
		73855,
		3855
	],
	"./replace.svg": [
		16234,
		6234
	],
	"./star.svg": [
		41497,
		1497
	],
	"./tag.svg": [
		60905,
		905
	],
	"./wishlist-line.svg": [
		62002,
		2002
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7257;
module.exports = webpackAsyncContext;